<div class="wrapper-container">
    <div class="wrapper">
        <article class="title">
            <div class="breadcrumb-padding">
                <lib-breadcrumbs [light]="true"></lib-breadcrumbs>
            </div>
            <h2 class="category-heading info-page-title">{{ pageTitle() }}</h2>
            @if (subheading()) {
                <h3 class="body-0 subheading info-page-title" [innerHTML]="subheading()"></h3>
            }
        </article>

        <section class="content">
            <ng-content></ng-content>
        </section>

        <lib-info-page-helpfull-links [links]="helpfullLinks" [title]="title()"></lib-info-page-helpfull-links>
    </div>
</div>
